import * as React from "react";
import { useState } from "react";
import { BasicEventCard } from "./BasicEventCard";
import { Button } from "antd";
import styled from "styled-components";
import { EventShortProps } from "../../types";

export const ParticipateButton = styled(Button)<{isInvolved?: boolean}>` 
  border-radius: 4px;
  height: 35px;
  padding: 5px 16px;
  background-color: ${(props) => props.isInvolved ? '#F8FCFF' : '#2196F3'};
  border: ${(props) => props.isInvolved ? '1px solid #DEF7E3' : '1px solid #F8FCFF'};
  color: ${(props) => props.isInvolved ? '#29A340' : '#FFFFFF'};
  cursor: ${(props) => props.isInvolved ? 'default' : 'pointer'};

  &:hover{
    border: ${(props) => props.isInvolved ? '1px solid #DEF7E3' : '1px solid #F8FCFF'}!important;
    color:  ${(props) => props.isInvolved ? '#29A340' : '#FFFFFF'}!important;
  }
`

export const StudentEventCard = ({event} : {event: EventShortProps}) => {
  const[isStudentInvolved, setIsStudentInvolved] = useState(event.isStudentInvolved);

  return(
    <BasicEventCard event={event}>
      <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 'auto' }}>
        {
          isStudentInvolved
            ? <ParticipateButton isInvolved>Я участвую</ParticipateButton>
            : <ParticipateButton type="primary" onClick={(e) => {e.stopPropagation(); setIsStudentInvolved(true)}}>Принять участие</ParticipateButton>
        }
      </div>
    </BasicEventCard>
  )
}